var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-page"},[_c('lan-1'),_c('lan-2'),_c('lan-3'),_c('lan-4'),_c('lan-5'),_c('lan-6'),_c('lan-10'),_c('lan-7'),_c('lan-8'),_c('div',{staticClass:"mx-auto",staticStyle:{"max-width":"900px"}},[_c('lan-9')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }